// extracted by mini-css-extract-plugin
export var buttonLink = "cardOt-module--buttonLink--4c515";
export var content = "cardOt-module--content--24e5d";
export var description = "cardOt-module--description--cb422";
export var heart = "cardOt-module--heart--7d462";
export var hideOverflow = "cardOt-module--hideOverflow--77b1d";
export var imageWrapper = "cardOt-module--imageWrapper--d5d0e";
export var likeWrapper = "cardOt-module--likeWrapper--b823c";
export var link = "cardOt-module--link--3504d";
export var price = "cardOt-module--price--c17fd";
export var priceFrom = "cardOt-module--priceFrom--a8373";
export var title = "cardOt-module--title--fc09f";
export var wrapper = "cardOt-module--wrapper--77580";